// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1qWgh","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2e4hW","obliqueLine":"membershipbadge_obliqueLine__2p1sM"};